const holidays = {
  headerButtons: {
    create: 'הוסף',
    delete: 'מחק',
  },

  table: {
    headers: {
      start: 'התחלה',
      end: 'סיום',
    },
    actions: {
      delete: 'מחק',
      export: 'ייצא',
    },
  },

  create: {
    successToast: {
      body: 'החג נוסף בהצלחה',
    },
    errorModal: {
      header: 'אירעה שגיאה',
      body: 'לא ניתן ליצור חג',
    },
  },
  delete: {
    successToast: {
      body: 'החגים נמחקו בהצלחה',
    },
    errorToast: {
      body: 'לא ניתן ליצור חג',
    },
  },
  edit: {
    errorToast: {
      body: 'לא ניתן ליצור חג',
    },
    successToast: {
      body: 'החג עודכן בהצלחה',
    },
    errorModal: {
      header: 'אירעה שגיאה',
      body: 'לא ניתן לעדכן חג',
    },
    successModal: {
      header: 'הצלחה',
      body: 'החג עודכן!',
    },
  },

  forms: {
    header: {
      create: {
        title: 'הוסף',
      },

      update: {
        title: 'עדכן',
      },
    },

    details: {
      header: 'פרטים',
      fields: {
        name: 'שם',
      },
    },
    dates: {
      header: 'טווח תאריכים',
      fields: {
        rangeSwitch: 'טווח תאריכים',
        start: 'התחלה',
        end: 'סיום',
        date: 'תאריך',
      },
    },
    footer: {
      confirmButtonText: {
        create: 'שמור',
        update: 'שמור',
      },
    },
  },
};

export default holidays;
